var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class merge_paragraphs_controller_default extends Controller {
  connect() {
    this.closeOnOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.closeMenu();
    };
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.closeMenu();
    };
    document.addEventListener("click", this.closeOnOutsideClick);
    document.addEventListener("keydown", this.closeOnEscape);
    this.refresh();
  }
  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick);
    document.removeEventListener("keydown", this.closeOnEscape);
  }
  checkboxTargetConnected() {
    this.refresh();
  }
  checkboxTargetDisconnected() {
    this.refresh();
  }
  refresh() {
    const selected = this.selected.length;
    this.countTarget.textContent = this.countLabelValue.replace("%{count}", selected);
    this.submitTarget.disabled = selected < 2;
    if (selected === 0) {
      this.barTarget.hidden = true;
      this.closeMenu();
    } else {
      this.barTarget.hidden = false;
    }
  }
  toggle() {
    if (this.menuTarget.hidden) this.openMenu();
    else this.closeMenu();
  }
  openMenu() {
    this.menuTarget.hidden = false;
    this.toggleTarget.setAttribute("aria-expanded", "true");
  }
  closeMenu() {
    if (!this.hasMenuTarget) return;
    this.menuTarget.hidden = true;
    this.toggleTarget.setAttribute("aria-expanded", "false");
  }
  submit() {
    const ids = this.selected.map((checkbox) => checkbox.value);
    if (ids.length < 2) return;
    this.closeMenu();
    const [source, ...targets] = ids;
    this.formTarget.action = this.urlTemplateValue.replace("__ID__", source);
    this.formTarget.querySelectorAll("[data-merge-target]").forEach((input) => input.remove());
    targets.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "merge_target_paragraph_ids[]";
      input.value = id;
      input.dataset.mergeTarget = "true";
      this.formTarget.appendChild(input);
    });
    this.formTarget.requestSubmit();
  }
  get selected() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }
}
__publicField(merge_paragraphs_controller_default, "targets", ["checkbox", "bar", "toggle", "menu", "count", "submit", "form"]);
__publicField(merge_paragraphs_controller_default, "values", { urlTemplate: String, countLabel: String });
